import get from 'lodash/get';

export const getMt4LiveCountries = (state) => {
  return get(state, 'mt4LiveCountries.countries', []);
};
